<script>
import Layout from '@layout/main'

export default {
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <div class="header__bg">
      <div class="pt-5"></div>
    </div>
    <section class="section text-center">
      <div class="mb-4">
        <div class="h-2 color-text font-semi-bold">
          404: Not Found
        </div>
      </div>
      <BaseButton
        class="isStylePrimary"
        :to="{ name: 'home' }"
      >
        回首頁
      </BaseButton>
    </section>
  </Layout>
</template>
